import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Rooms from "@/components/site/Rooms";
import Gallery from "@/components/site/Gallery";
import Restaurant from "@/components/site/Restaurant";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#FAF9F5] text-[#1A1C19]">
      <Navbar />
      <Hero />
      <Rooms />
      <Gallery />
      <Restaurant />
      <Contact />
      <Footer />
    </main>
  );
}
